import React, { createContext, useContext, useState } from "react";
import { useFetchOncePerUser } from "../hooks/useFetchOncePerUser";
import { useAuth } from "./AuthContext";
import { userAPI } from "../services/api";

const UserContext = createContext();

export const useUsers = () => useContext(UserContext);

export const UserProvider = ({ children }) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user: currentUser } = useAuth();

  async function fetchUsers() {
    try {
      setLoading(true);
      const response = await userAPI.getAll();
      setUsers(response.data || []);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  }
  useFetchOncePerUser(currentUser, fetchUsers);

  const addUser = async (userData) => {
    try {
      const response = await userAPI.create(userData);
      const newUser = response.data;
      setUsers((prev) => [...prev, newUser]);
      return newUser;
    } catch (error) {
      console.error("Error adding user:", error);
      throw error;
    }
  };

  const updateUser = async (userId, updatedData) => {
    try {
      const response = await userAPI.update(userId, updatedData);
      const updated = response.data;
      setUsers((prev) =>
        prev.map((u) => (u._id === userId || u.id === userId ? updated : u))
      );
      return updated;
    } catch (error) {
      console.error("Error updating user:", error);
      throw error;
    }
  };

  const deleteUser = async (userId) => {
    try {
      await userAPI.delete(userId);
      setUsers((prev) => prev.filter((u) => u._id !== userId && u.id !== userId));
    } catch (error) {
      console.error("Error deleting user:", error);
      throw error;
    }
  };

  return (
    <UserContext.Provider
      value={{
        users,
        loading,
        fetchUsers,
        addUser,
        updateUser,
        deleteUser,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export default UserProvider;
